import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';

const DEFAULT_FILTERS = { status: '', owner: '' };

const DepartmentFilters = ({ filters = DEFAULT_FILTERS, onFilterChange, companyUsers = [] }) => {
  const handleChange = (key, value) => {
    onFilterChange({ ...filters, [key]: value === 'all' ? '' : value });
  };

  const handleClear = () => {
    onFilterChange(DEFAULT_FILTERS);
  };

  const hasActiveFilters = filters.status || filters.owner;

  return (
    <div className="flex flex-wrap items-center gap-3 p-3 bg-gray-50 dark:bg-gray-800 rounded-lg border mb-3">
      {/* Status filter */}
      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-600 dark:text-gray-400 whitespace-nowrap">Status:</span>
        <Select
          value={filters.status || 'all'}
          onValueChange={(val) => handleChange('status', val)}
        >
          <SelectTrigger className="h-8 w-32 text-sm">
            <SelectValue placeholder="All" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All</SelectItem>
            <SelectItem value="active">Active</SelectItem>
            <SelectItem value="archived">Archived</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {/* Owner filter */}
      {companyUsers.length > 0 && (
        <div className="flex items-center gap-2">
          <span className="text-sm text-gray-600 dark:text-gray-400 whitespace-nowrap">Owner:</span>
          <Select
            value={filters.owner || 'all'}
            onValueChange={(val) => handleChange('owner', val)}
          >
            <SelectTrigger className="h-8 w-44 text-sm">
              <SelectValue placeholder="All owners" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All owners</SelectItem>
              {companyUsers.map((u) => (
                <SelectItem key={u._id} value={u._id}>
                  {u.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}

      {/* Clear button */}
      {hasActiveFilters && (
        <Button variant="ghost" size="sm" onClick={handleClear} className="h-8 text-xs gap-1">
          <X className="h-3 w-3" />
          Clear filters
        </Button>
      )}
    </div>
  );
};

export default DepartmentFilters;
